import { Injectable } from "@angular/core";

const KEY = 'smart.token';
const REFRESH_KEY = 'smart.refresh.token';
@Injectable({  providedIn: 'root'})
export class TokenService {

    hasToken() {
        if(this.getToken() == '')
            return false;
        else
            return true;
    }

    setToken(token: string, refresh: string) {

        localStorage.setItem(KEY, token);
        localStorage.setItem(REFRESH_KEY, refresh);
    }

    getToken(): string {

       let token = window.localStorage.getItem(KEY);
       if(!token)
        return '';
      else
        return token;
    }
    getRefreshToken(): string {
      return localStorage.getItem(REFRESH_KEY) || '';
    }

    removeToken() {
      localStorage.removeItem(KEY);
      localStorage.removeItem(REFRESH_KEY);
    }

}
